import { useState, useEffect } from 'react'
import { Typography, Button, IconButton, Box, Stack,
         InputLabel, TextField, Select, Table, TableContainer,
         TableHead, TableBody, TableRow, TableCell, Pagination,
         Checkbox, FormControlLabel
       } from '@mui/material'
import { useConfirm } from '@/components/ConfirmProvider'
import AuthDialog     from '@pages/Mng/MS/SSM/AuthDialog'
import UserDialog     from '@pages/Mng/MS/SSM/TestUserDialog'
import { admSend }    from 'api/users';
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * 권한 관리 등록 화면
 **/
function UserGrp () {
  const navigate = useNavigate();
  const location = useLocation();
  const { alert, confirm } = useConfirm();

  const searchYn = location.state?.searchYn;
  const navParamData = location.state?.navParamData;

  /* 권한 팝업 */
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const handleAuthOpenDialog = () => setAuthDialogOpen(true);   // Dialog Open
  const handleAuthCloseDialog = () => setAuthDialogOpen(false); // Dialog Close

  /* 회원 팝업 */
  const [userDialogOpen, setUserDialogOpen] = useState(false);
  const handleUserOpenDialog = () => setUserDialogOpen(true);   // Dialog Open
  const handleUserCloseDialog = () => setUserDialogOpen(false); // Dialog Close

  // 등록 정보.
  const [writeData, setWriteData] = useState({
    workGroupName : "",
    authGroupId   : "",
    authGroupName : "",
    authGradeCode : "",
    authGradeName : "",
    writeDataList : []
  });     // 조회조건
  const [userList, setUserList] = useState([]);   // 그룹구성원
  const [selected, setSelected] = useState([]);

// ====================== 공통 함수 ======================
  // 전체 선택
  const handleSelectAll = (checked) => {
    if( userList?.length > 0){
      if (checked) {
        setSelected(userList.map((r) => r.accountId));
      } else {
        setSelected([]);
      }
    }
  };

  // 단건 선택
  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const allSelected  = selected.length === userList?.length && userList?.length > 0;
  const someSelected = selected.length > 0 && !allSelected;

// ====================== 사용자 업무 함수 ======================
  /* 유효성 검사 */
  const validation = () => {

    if( !writeData.workGroupName ) {
      alert('그룹명이 입력되지 않았습니다.');
      return false;
    }
    
    if( !writeData.authGroupId ) {
      alert('권한이 선택되지 않았습니다.');
      return false;
    }
    
    return true;
  }

  /* 그룹구성원 삭제 */
  const delUser = async (accountId) => {
    const resConfirm = await confirm({title : '', message : '삭제 하시겠습니까?'});
    if ( resConfirm ) {
      setUserList((prev) => prev.filter((user) => user.accountId !== accountId));
    }
  }

  /* 사용자 그룹 등록 */
  const saveUserGrp = async (data) => {

    if( validation() ) {
      const resConfirm = await confirm({title : '', message : '등록 하시겠습니까?'});

      if ( resConfirm ) {
        const resDel = await admSend('/saveUserGrpInfo', data);

        if ( resDel ) {
          // 등록완료 후 목록화면 이동
          // console.log("이동=="+navParamData);
          navigate('/mng/userGrp',   { state: { searchYn : searchYn, navParamData : navParamData} }); 
        }
      }
    }

  }

// ====================== CallBack 함수 ======================
  // 권한검색 다이얼로그에서 콜백
  const handleConfirmAuth = (auth) => {
    setWriteData((data) => ({
      ...data,
      authGradeCode : auth.authGradeCode,
      authGradeName : auth.authGradeName,
      authGroupId   : auth.authGroupId,
      authGroupName : auth.authGroupName,
    }));
  };

  // 권한검색 다이얼로그에서 콜백
  const handleConfirmUser = (user) => {
    if ( user ) {
      const newUser = {
          rowNum : user.rowNum
        , accountId : user.accountId
        , authGradeName : user.memberInstName
        , authGradeCode : user.memberInstCode
        , memberEmail : user.memberEmail
        , memberName : user.memberName
      };

      setUserList((prev) => {
        // 🔍 중복 체크 (accountId 기준)
        const isDuplicate = prev.some(
          (u) => u.accountId === newUser.accountId
        );

        if (isDuplicate) {
          alert("이미 추가된 사용자입니다.");
          return prev; // 변경 없이 그대로 반환
        }
        return [...prev, newUser]
      });
    }
  };

  /* 최초 실행 */
  useEffect(() => {
    // console.log("navParamData:"+navParamData)
  }, [navParamData]);

  return (
    <div>
      <AuthDialog open={authDialogOpen} onClose={handleAuthCloseDialog} onConfirm={handleConfirmAuth} />
      <UserDialog open={userDialogOpen} onClose={handleUserCloseDialog} onConfirm={handleConfirmUser} />

      <Stack direction="row" alignItems="center" spacing={2} p={0.3}>
        {/* 그룹명 */}
        <Typography sx={{ width: 100 }}>그룹명</Typography>
        <TextField
          id="authGroupName" 
          name="authGroupName" 
          sx={{ width: 580 }}
          label="그룹명을 입력해 주세요"
          value={writeData.workGroupName}
          onChange={(e) => {
            setWriteData({
              ...writeData,
              workGroupName : e.target.value
            })        
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" spacing={2} p={0.3}>
        {/* 권한설정 */}
        <Typography sx={{ width: 100 }}>권한설정</Typography>
        <TextField
          id="authGroupName" 
          name="authGroupName" 
          sx={{ width: 580 }}
          label="권한을 검색해 주세요"
          value={writeData.authGroupName}
          onChange={(e) => {
            setWriteData({
              ...writeData,
              authGroupName : e.target.value
            })
          }}
          disabled={true}
        />

        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
          <Button 
            size="small"
            variant="outlined"
            onClick={handleAuthOpenDialog}
            sx={{
              whiteSpace: 'nowrap',
              minWidth: 'auto',
              px: 2,
              py: 1,
              backgroundColor: '#FFF',
              '&:hover': {
                backgroundColor: '#FAFAFA'
              }
            }}
          >권한검색</Button>
        </Box>
      </Stack>
        
      <Stack direction="row" alignItems="center" spacing={2} p={0.3}>
        {/* 기관 */}
        <Typography sx={{ width: 100 }}>기관</Typography>
        <TextField
          sx={{ width: 580 }}
          id="authGradeName" 
          name="authGradeName" 
          value={writeData.authGradeName}
          onChange={(e) => {
            setWriteData({
              ...writeData,
              authGradeName : e.target.value
            })
          }}
          disabled={true}
        />
      </Stack>

      <Stack direction="row" alignItems="center" spacing={2} p={2}>
        {/* 권한설정 */}
        <Typography sx={{ width: 100 }}>그룹구성원</Typography>
        <TableContainer sx={{ mt: 3 }}>
          <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }} p={1}>
            <Button 
              size="small"
              variant="outlined"
              sx={{
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                alignItems: 'left',
                px: 2,
                py: 1,
                backgroundColor: '#FFF',
                '&:hover': {
                  backgroundColor: '#FAFAFA'
                }
              }}
              // onClick={handleAuthOpenDialog}
            >마스팅해제</Button>
            <Button 
              size="small"
              variant="outlined"
              sx={{
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                px: 2,
                py: 1,
                backgroundColor: '#FFF',
                '&:hover': {
                  backgroundColor: '#FAFAFA'
                }
              }}
              onClick={delUser}
            >삭제</Button>
            <Button 
              size="small"
              variant="outlined"
              sx={{
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                px: 2,
                py: 1,
                backgroundColor: '#FFF',
                '&:hover': {
                  backgroundColor: '#FAFAFA'
                }
              }}
              onClick={handleUserOpenDialog}
            >추가</Button>
          </Box>

          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" sx={{bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        indeterminate={someSelected}
                        checked={allSelected}
                        onChange={(e) => handleSelectAll(e.target.checked)}
                      />
                    }
                    // label={"전체선택"}
                  />
                </TableCell>
                <TableCell align="center" sx={{width: '60px', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>번호</TableCell>
                <TableCell align="center" sx={{width: '30%', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>이름</TableCell>
                <TableCell align="center" sx={{width: '30%', bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>메일</TableCell>
                <TableCell align="center" sx={{bgcolor: 'grey.50', borderTop: '1px solid', borderColor: 'divider'}}>기관명</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {
                userList?.length === 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={5}>등록된 메뉴가 없습니다.</TableCell>
                  </TableRow>
                ) : (
                  userList?.map((user, index) => (
                    <TableRow key={user.accountId}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          value={user.rowChkYn === "Y" ? "Y" : "N"}
                          checked={selected.includes(user.accountId)}
                          onChange={(e) => {
                            const checked = e.target.checked ? "Y" : "N";
                            handleSelect(user.accountId)
                            // 조회 정보에 체크 상태 변경.
                            setUserList((prev) =>
                              prev.map((item) =>
                                item.accountId === user.accountId ? { ...item, rowChkYn : checked } : item
                              )
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">{user.memberName}</TableCell>
                      <TableCell>{user.memberEmail}</TableCell>
                      <TableCell>{user.authGradeName}</TableCell>
                    </TableRow>
                  ))
                )
              }
            </TableBody>
          </Table>
        </TableContainer>

      </Stack>

      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1, mt: 2 }}>
        <Button
          sx={{ p: 3, border: '13px', borderRadius: '8px' }}
          variant="contained"
          color="primary"
          onClick={() => {
            navigate('/mng/userGrp',   { state: { searchYn : searchYn, navParamData : navParamData} });
          }}
        >취소</Button>
        <Button
          sx={{ p: 3, border: '13px', borderRadius: '8px' }}
          variant="contained"
          color="primary"
          onClick={() => {
            const saveData = {
              ...writeData,
              writeDataList : userList
            };
            saveUserGrp(saveData);
          }}
        >등록</Button>
      </Box>

    </div>

  )
}

export default UserGrp;